import { useMemo } from 'react';

import { checkIsValidJSON } from '@/services/helpers/checkIsValidJSON';
import type { TAltynResponse } from '@/types/altynResponse.type';

import type { TBankOffers } from '../../../types/bank-offer.types';

interface IProps {
  bankOffer: TBankOffers;
}

const useAlternatives = ({ bankOffer }: IProps) => {
  const hasAlternatives = Boolean(
    bankOffer.alternatives && bankOffer.alternatives?.length > 0
  );

  const altynBankData = useMemo(() => {
    if (hasAlternatives) return { alternatives: null };

    const parsedAltynResponse =
      bankOffer.responseApprovedBody &&
      checkIsValidJSON(bankOffer.responseApprovedBody)
        ? JSON.parse(bankOffer.responseApprovedBody)
        : null;
    const alternatives: TAltynResponse[] | null = Array.isArray(
      parsedAltynResponse
    )
      ? parsedAltynResponse
      : null;

    return { alternatives };
  }, [bankOffer, hasAlternatives]);

  const alternatives: TBankOffers['alternatives'] = useMemo(() => {
    if (hasAlternatives) return bankOffer.alternatives || [];

    if (altynBankData.alternatives && altynBankData.alternatives.length > 0) {
      return altynBankData.alternatives.map((item) => ({
        extUuid: item.offerId, // Используется для отправки в банки
        initialPayment: String(item.initialPayment),
        loanAmount: String(item.amount),
        loanPeriod: String(item.loanDuration),
        monthlyPayment: String(item.monthlyPayment),
        rate: item.percentRate,
        responseUuid: bankOffer.id,
        uuid: item.offerId // Внутренний uuid
      }));
    }

    return [];
  }, [altynBankData.alternatives, bankOffer.alternatives, bankOffer.id]);

  return { alternatives };
};

export default useAlternatives;
